import PropTypes from 'prop-types';

export default PropTypes.arrayOf(
  PropTypes.shape({
    profileUrl: PropTypes.string,
    name: PropTypes.string,
  }),
);
